import { Box, Chip, Typography, CircularProgress } from "@mui/material";
import Lottie from "react-lottie";
import { assets } from "../../assets";
import { AnimatePresence, motion } from "framer-motion";
import { useClients } from "../clients/hooks/useClients";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { colors } from "../ui/colors";
import { ClientsTable } from "../clients/clientsTable";
import { useModals } from "../../context/ModalContext";
import { useDialog } from "../ui/dialogs/useDialog";
import { selectClientSelection } from "../../redux/features/quotes/quote-create-advanced/selectors/clientSelectors";
import { quoteCreateActions } from "../../redux/features/quotes/quote-create-advanced";

export const JobsClients = () => {
  const { getAllClients, clients, loading } = useClients();
  const client = useSelector(selectClientSelection);
  const dispatch = useDispatch();
  const { setClientSelection } = quoteCreateActions;

  const { closeByKey } = useModals();
  const { showDialog, DialogComponent } = useDialog();

  useEffect(() => {
    getAllClients({});
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        "& .MuiPaper-root": { overflow: "visible !important" },
        "& .MuiDialogContent-root": { overflow: "visible !important" },
        position: "relative",
      }}
    >
      {/* LOADING */}
      {loading && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(var(--fx-surface-basergb, 255, 255, 255), 0.6)",
            zIndex: 1000,
          }}
        >
          <CircularProgress size={50} sx={{ color: colors.orange.base }} />
        </Box>
      )}

      {/* CONTENEDOR PRINCIPAL */}
      <Box
        sx={{
          flex: 1,
          overflowX: "visible",
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          position: "relative",
        }}
      >
        {/* CHIP */}
        <AnimatePresence>
          {(client?.clientCompanyName || client?.firstName) && (
            <Chip
              sx={{
                width: { xs: "90%", sm: "70%", md: "50%" },
                mx: "auto",
                mb: 1,
                color: colors.gray[900],
                bgcolor: colors.orange[100],
                zIndex: 10,
                fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.9rem" },
              }}
              component={motion.div}
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0, opacity: 0 }}
              transition={{ duration: 0.6, type: "spring" }}
              label={`Client ${client?.clientCompanyName || `${client?.firstName} ${client?.lastName}`} at ${client?.coverageArea?.address}.`}
              onDelete={() => dispatch(setClientSelection(null))}
            />
          )}
        </AnimatePresence>

        <ClientsTable
          sx={{ width: "95%", overflow: "visible", mb: 2 }}
          maxRowPerPage={8}
          disableMenuOptions
          allowSelected
          disableRecordClickable={true}
          onSelectClientAndCoverage={(selectedClient) => {
            showDialog({
              type: "confirm",
              title: "Select this client?",
              message: `Do you want to select ${
                selectedClient.clientCompanyName || `${selectedClient.firstName} ${selectedClient.lastName}`
              } as the client for this quote?`,
              confirmLabel: "Yes, select",
              cancelLabel: "Cancel",
              onConfirm: () => {
                dispatch(setClientSelection(selectedClient));
                setTimeout(() => {
                  closeByKey("Select-Client-Quote");
                }, 100);
              },
              onCancel: () => {},
            });
          }}
        />

        {!loading && clients.items?.length === 0 && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              pointerEvents: "none",
            }}
          >
            <Typography color="text.secondary" sx={{ mb: 2, width: "300px", lineHeight: 1 }}>
              Oops! There aren't clients, create a new one.
            </Typography>

            <Lottie isClickToPauseDisabled height="200px" width="200px" options={{ animationData: assets.animation.notFound }} />
          </Box>
        )}
      </Box>

      {DialogComponent}
    </Box>
  );
};
